module.exports = __webpack_public_path__ + "static/media/400011_01.2de33640.png";